/**
 * Larghezza sidebar compressa (desktop) e drawer stretto (mobile): logo icona 64px + margine, linguetta.
 * Se cambi questo valore, aggiorna anche le classi `w-[96px]` / `max-w-[96px]` in SidebarNavigation.jsx.
 */
export const SIDEBAR_RAIL_WIDTH_PX = 96;
